<template>
	<Dialog
		titulo="Conferencia Digital"
		subtitulo="Caso não tenha acontecido algo, apenas clique em salvar."
		btn_acao="Salvar"
		btn_cancelar="Cancelar"
		@acao="salvar()"
		@close="fecharModal()"
		:loading="loading">
		<v-layout wrap>
			<v-flex xs3>
				<v-navigation-drawer class="nav" width="290">
					<v-date-picker
						locale="pt-br"
						:no-title=true
						v-model="date"
						:allowed-dates="allowedDates"
						:max="maxData()"
						:min="minData()"/>
					<v-list dense>
						<v-list-tile v-for="(sache, index) in sacheMenuDay()" :key="index" @click="selectSache(sache.index)">
							<v-list-tile-action>
								<v-icon>fa-calendar</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{ sache.label }}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</v-navigation-drawer>
			</v-flex>
			<v-flex xs9>
				<div v-if="!loading && selected">
					<h2>{{ selected.scheduled_date }} - {{ selected.id }}</h2>
					<h3>{{ selected.scheduled_label }}</h3>
					<div v-for="medicamento in selected.sache_medicamentos" :key="medicamento.id" class="medicamento-details">
						<v-chip class="ma-2" color="primary" text-color="white">
							{{ medicamento.quantidade }} - {{ medicamento.box_medicamento.medicamento.produto }} - {{ medicamento.box_medicamento.medicamento.dosagem }}
						</v-chip>
					</div>
					<div v-for="image in images" :key="image.id">
						<img :src="image.front_image" alt="Imagem da conferência digital" width="40%">
						<img :src="image.back_image" alt="Imagem da conferência digital" width="40%">
					</div>
				</div>
			</v-flex>
		</v-layout>
	</Dialog>
</template>

<script>
import { SachePresenter } from '@Presenter/sache-presenter';
import $http from '@Config/farme-ai';

export default {
	name: 'DialogConferenciaDigital',
	props: {
		box_id: {
			type: Number,
			required: true
		},
		request: {
			type: Function,
			required: true
		}
	},
	data: () => ({
		loading: true,
		saches: [],
		selected: null,
		images: [],
		date: null
	}),
	async created() {
		SachePresenter.show(this.box_id)
			.then(res => {
				if (res.length === 0) {
					this.$store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Essa box não possui conferência digital' });
					this.fecharModal();
					return;
				}
				this.saches = res;
				this.date = this.minData();
				this.selectSache(this.sacheMenuDay()[0].index);
			})
			.catch(() => {
				this.fecharModal();
			})
			.finally(() => {
				this.loading = false;
			});
	},
	methods: {
		async selectSache(index) {
			this.selected = this.saches[index];
			this.images = await $http.get(`/bag/${this.selected.id}/image`);
		},
		salvar() {
			this.loading = true;
			Promise.all([
				SachePresenter.store({
					box_id: this.box_id
				}),
				this.request()
			])
				.then(() => {
					this.fecharModal();
				})
				.finally(() => {
					this.loading = false;
				});
		},
		fecharModal() {
			this.$emit('update:close', false);
		},
		sacheMenu() {
			return this.saches.reduce((acc, sache, index) => {
				// Using split method to remove time part and leave only the date
				const date = sache.scheduled_date.split(' ')[0];
				// If the date is not present in the accumulator, create an empty array for it
				if (!acc[date])
					acc[date] = [];
				// Append new object to the corresponding date
				acc[date].push({
					label: sache.scheduled_label,
					id: sache.id,
					index
				});
				return acc;
			}, {});
		},
		sacheMenuDay() {
			return this.sacheMenu()[this.date];
		},
		allowedDates(val) {
			// console.log(val);
			// console.log(Object.keys(this.sacheMenu()));
			// console.log(Object.keys(this.sacheMenu()).includes(val));
			return Object.keys(this.sacheMenu()).includes(val);
		},
		minData() {
			return Object.keys(this.sacheMenu())[0];
		},
		maxData() {
			return Object.keys(this.sacheMenu())[Object.keys(this.sacheMenu()).length - 1];
		}
	},
	computed: {

	}
};
</script>

<style lang="scss" scoped>
@import "@Assets/css/settings.scss";
.sache {
	margin-bottom: 20px;
}

.medicamento {
	background: rgba(0,0,0,.03);
	border-radius: 10px;
	padding: 10px;
	margin-bottom: 10px;
}

.produto, .dosagem, .quantidade {
	display: block; // Ou flex, dependendo do layout desejado
}
.chip {
	display: inline-block;
	background: rgba(0,0,0,.06);
	border-radius: 15px;
	padding: 5px 10px;
	margin: 5px;

	&.selected {
		background: $purple;
		color: white;
	}
}
</style>
